import { render, staticRenderFns } from "./AddCollaboratorConfig.vue?vue&type=template&id=35437fa0&scoped=true"
import script from "./AddCollaboratorConfig.vue?vue&type=script&lang=js"
export * from "./AddCollaboratorConfig.vue?vue&type=script&lang=js"
import style0 from "./AddCollaboratorConfig.vue?vue&type=style&index=0&id=35437fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35437fa0",
  null
  
)

export default component.exports